//import 'jquery/dist/jquery.min';

// Import everything from autoload
import "./autoload/_bootstrap.js"

import 'slick-carousel/slick/slick';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';

/**
 * @see https://api.jqueryui.com/datepicker/
 * for usage and dependencies
 */
import 'jquery-ui/ui/widget';
import 'jquery-ui/ui/effect';
import 'jquery-ui/ui/widgets/datepicker';

/*
* http://leafo.net/sticky-kit/#reference
* https://github.com/leafo/sticky-kit
*
 */
import 'sticky-kit/dist/sticky-kit.min';

require('./libs/advivapress.js');
require('./libs/adviva.js');

// PROJECT
require('../_project/scripts/project');
